import { render } from "./FatturaStornoCard.vue?vue&type=template&id=65c8fafc&scoped=true"
import script from "./FatturaStornoCard.vue?vue&type=script&lang=js"
export * from "./FatturaStornoCard.vue?vue&type=script&lang=js"

import "./FatturaStornoCard.vue?vue&type=style&index=0&id=65c8fafc&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c8fafc"]])

export default __exports__